import React, { useEffect, useState, useContext } from 'react';
import GiustificativiRichiesteNull from '../components/giustificativi_richieste_null';
import Footer from '../components/footer';
import { AuthContext } from '../contexts/auth';
import { Link } from 'wouter';
import PopoverComponentCustom from '../components/popover_component';


const PendingJustifications = () => {
    const { token, profile } = useContext(AuthContext);

    const isProfileComplete = profile.has_complete_profile;

      
    return <>
        <div className="flex flex-col min-h-screen">
            <PopoverComponentCustom title="Richieste Giustificativi da Gestire" />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                            <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                            >
                            cliccando qui
                            </Link>
                        </p>
                    </div>
                </div>
            )}
            <main className="flex-grow mt-10 pb-8">
                <GiustificativiRichiesteNull />  
            </main>
            <Footer />
        </div>

    </>

  };
  
  export { PendingJustifications }